import { Card, IconButtonGroup } from '@travelity/ui';
import React from 'react';
import { Divider, Skeleton, Stack } from '@mui/material';

export const ProductVariantCardSkeleton = () => {
    return (
        <Card
            buttons={
                <IconButtonGroup
                    flexShrink={0}
                    sx={{ px: 0.75, py: 1 }}
                    gap={1.5}
                >
                    <Skeleton variant="circular" width={24} height={24} />
                </IconButtonGroup>
            }
        >
            <Stack>
                <Stack
                    direction="row"
                    gap={2}
                    justifyContent="space-between"
                    sx={{
                        width: 1,
                        px: 2,
                        pt: 1,
                        pb: 1,
                        bgcolor: '#F4F6FA',
                        borderRadius: '12px 0px 0px 0px',
                    }}
                >
                    <Skeleton width={90} sx={{ fontSize: '24px' }} />
                    <Stack direction="row" gap={1}>
                        <Skeleton width={60} sx={{ fontSize: '24px' }} />
                        <Skeleton width={40} sx={{ fontSize: '24px' }} />
                    </Stack>
                </Stack>
                <Stack
                    direction="row"
                    gap={2}
                    justifyContent="space-between"
                    sx={{
                        width: 1,
                        px: 2,
                        pt: '8px',
                        pb: '12px',
                    }}
                >
                    <Skeleton width={90} sx={{ fontSize: '24px' }} />
                    <Stack direction="row" gap={1}>
                        <Skeleton width={100} sx={{ fontSize: '24px' }} />
                        <Skeleton width={100} sx={{ fontSize: '24px' }} />
                        <Skeleton width={40} sx={{ fontSize: '24px' }} />
                    </Stack>
                </Stack>
            </Stack>
        </Card>
    );
};
